import React, { useContext } from "react";
import { Grid, Card } from "@material-ui/core";
import classNames from "classnames";
import { useNavigate } from "@reach/router";
import { Button } from "components/haven-design";
import { Page } from "../type";
import { onSendEmailVerification } from "../meteor";
import LoginModalContext from "../context/modal";
import { LoginCardTitle, LoginCardSubtitle } from "./shared-components";
import styles from "./Login.module.css";

const getVerifyRedirectURL = (inModal: boolean, formId?: string) => {
  if (formId) return `${window.location.origin}/form/${formId}`;
  if (!inModal) return `${window.location.origin}/email-verified`;
  const link = window.location.href;
  const joiner = link.includes("?") ? "&" : "?";
  return `${link}${joiner}verify=true`;
};

// eslint-disable-next-line max-lines-per-function
const WaitToVerify: Page<"wait-to-verify"> = (props) => {
  const { inModal } = useContext(LoginModalContext);
  React.useEffect(() => {
    const redirectURL = getVerifyRedirectURL(inModal, props.formId);
    onSendEmailVerification(props.username, { redirectURL });
  }, [props.username]);

  const navigate = useNavigate();

  const redirectUser = () => {
    if (location.pathname === "/signup") {
      navigate("/login");
    } else {
      props.onNavigate({ page: "login", props: {} });
    }
  };

  return (
    <div className={styles.form}>
      <Card className={classNames(styles.loginCard, { [styles.borderlessCard]: inModal })}>
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <LoginCardTitle title="Verify your account" />
          </Grid>
          <Grid item>
            <LoginCardSubtitle>
              <strong>
                We sent an email to {props.username}
              </strong> containing a link to securely verify
              your account. Once clicked, you&apos;ll be able to login with your new user account.
            </LoginCardSubtitle>
          </Grid>
          <Grid item>
            <Button
              size="L"
              color="primary"
              onClick={() => redirectUser()}
              className={styles.loginButton}
            >
              Login after verification
            </Button>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default WaitToVerify;
